import * as React from "react";
import * as ReactDOM from "react-dom";
import {connect} from "react-redux";
import Button from '../../../common/ui/button/Button';
import {showMainMenu} from '../../../../store/actions/screens';
import {stopTimer} from '../../../../store/actions/timer';

interface Props
{
    showMainMenu: () => void;
    stopTimer: () => void;
}


class QuitButton extends React.Component<Props, null>
{
    constructor(public props: Props)
    {
        super(props);
    }


    onQuit = () =>
    {
        const {showMainMenu, stopTimer} = this.props;

        showMainMenu();
        stopTimer();
    };


    render()
    {
        return <Button
            type={'quit-game'}
            onClick={this.onQuit}>

            quit

        </Button>;
    }
}



const mapStateToProps = state =>
{
    return {
    }
};


const mapDispatchToProps = dispatch =>
{
    return {
        showMainMenu: () => dispatch(showMainMenu()),
        stopTimer: () => dispatch(stopTimer()),
    }
};


export default connect(mapStateToProps, mapDispatchToProps)(QuitButton);



// WEBPACK FOOTER //
// ./src/ts/app/screens/game/hints-button/QuitButton.tsx